import { ConnectionChangeRequestStatusEnum } from '@bo-client/shared/models/connectionChange.dto';
import { StatusRuleSet } from '../status-availability.model';

/** Anschlussänderung: Status, die kein Prozessschritt erreicht. */
export const CONNECTION_CHANGE_REQUEST_STATUS_RULES: StatusRuleSet = {
  blacklist: {
    [ConnectionChangeRequestStatusEnum.Incomplete]: null,
    [ConnectionChangeRequestStatusEnum.Expired]: null,
    [ConnectionChangeRequestStatusEnum.Error]: null
  }
};
